import { useState } from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'

import routes from '../../routers'

import './style.css'

const DISMISSED_KEY = 'cardExpiryBannerDismissed'
const pad = (n) => String(n).padStart(2, '0')

// Which warning (card and state) was closed, so a new one still shows
const alertKey = (alert) =>
  `${alert.state}:${alert.last4}:${alert.expiry_year}-${pad(alert.expiry_month)}`

const isDismissed = (alert) => {
  try {
    return window.sessionStorage.getItem(DISMISSED_KEY) === alertKey(alert)
  } catch (e) {
    return false
  }
}

export const cardAlertText = (alert) => {
  const expiry = `${pad(alert.expiry_month)}/${String(alert.expiry_year).slice(-2)}`
  return alert.state === 'expired'
    ? `The card your Pro plan renews on (ending ${alert.last4}) expired ${expiry}.`
    : `The card your Pro plan renews on (ending ${alert.last4}) expires ${expiry}.`
}

// Shown when Chargebee says the card Pro renews on is about to run out
// (user.card_alert from /me). Closing it hides it until the next visit.
const CardExpiryBanner = () => {
  const alert = useSelector((state) => state.user?.data?.card_alert)
  const { pathname } = useLocation()
  const [closed, setClosed] = useState('')

  // The account page shows the same message beside the card itself
  if (!alert || pathname === routes.settings) return null
  if (closed === alertKey(alert) || isDismissed(alert)) return null

  const dismiss = () => {
    try {
      window.sessionStorage.setItem(DISMISSED_KEY, alertKey(alert))
    } catch (e) {
      // Browser storage is blocked (e.g. private mode): hide it for now only
    }
    setClosed(alertKey(alert))
  }

  return (
    <div
      className={`cardExpiryBanner${alert.state === 'expired' ? ' cardExpiryBannerExpired' : ''}`}
      role="region"
      aria-label="Your card"
    >
      <div className="cardExpiryInner">
        <p className="cardExpiryText">
          {cardAlertText(alert)} Update it so you keep Pro.
          <Link className="cardExpiryLink" to={`${routes.settings}#billing`}>
            Update card
          </Link>
        </p>
        <button
          type="button"
          className="cardExpiryClose"
          onClick={dismiss}
          aria-label="Close this message"
        >
          ×
        </button>
      </div>
    </div>
  )
}

export default CardExpiryBanner
